

export const wan = {
    tabs: { textToVideo: 'Text to Video', imageToVideo: 'Image to Video' },
    upload: {
      addImage: 'Add Image',
      formats: 'JPG, PNG, WebP • Max 10MB'
    },
    prompt: {
      label: 'Prompt',
      placeholder: 'Describe the video you want to generate...',
      sub: 'Describe your desired video motion and content',
      count: '{count} / 800'
    },
    groups: {
      duration: 'Duration',
      resolution: 'Resolution',
      aspect: 'Aspect Ratio',
      aspectInfo: 'The output video aspect ratio will match your uploaded image'
    },
    advanced: {
      title: 'Advanced Settings',
      negativePrompt: 'Negative Prompt',
      negativePlaceholder: "Describe what you don't want in the video...",
      negativeHelp: 'Optional: Describe content to avoid in the generated video',
      seed: 'Seed',
      seedPlaceholder: 'Random (leave empty)',
      seedHelp: 'Optional: Use a specific seed for reproducible results'
    },
    credits: { bar: 'Credits Cost', value: '{value} credits' },
    actions: { generate: 'Generate Video ({value} credits)' },
    preview: { title: 'Ready to Create', desc: 'Configure your settings and click generate to start creating amazing videos' }
  };
